import React, { useContext } from 'react'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import { StoresContext } from '@App/contexts'
import Pluralize from 'pluralize'

interface ImportCatalogErrorModalProps {
    closeAndReset: (isOpen: boolean) => void
}
const ImportCatalogErrorModal = ({ closeAndReset }: ImportCatalogErrorModalProps) => {
    const { catalogTransferWizardStore } = useContext(StoresContext)

    const errors = catalogTransferWizardStore.importResult?.errors || []
    const errorCount = errors.length
    const errorHeader = (
        <>
            <strong>{errorCount}</strong> {Pluralize('work', errorCount)}
            {errorCount >= 20 ? ' or more' : ''} {Pluralize('has', errorCount)} an error.
        </>
    )
    const mappedErrors = errors.reduce((map, { message, rowNumber }) => {
        if (!map.has(message)) {
            map.set(message, [])
        }
        map.get(message)!.push(rowNumber)
        return map
    }, new Map<string, string[]>())

    return (
        <Popup onClose={() => closeAndReset(false)}>
            <ConfirmationPopup
                title="An error has occurred. Please review your Excel file."
                onConfirm={() => closeAndReset(false)}
                confirmButtonText="Done"
                popupClassName="import-complete-modal"
            >
                <div className="import-complete-copy">
                    <div className="import-complete-header">{errorHeader}</div>
                    <div className="import-error">
                        {[...mappedErrors].map(([error, rows]) => (
                            <div key={error}>
                                {Pluralize('Line', rows.length)} #{rows.join(', ')}: {error}
                            </div>
                        ))}
                    </div>
                    <div>Please review your Excel file, fix any errors you find, and then upload it again.</div>
                </div>
            </ConfirmationPopup>
        </Popup>
    )
}

export default ImportCatalogErrorModal
